import { LoaderCircle, X } from 'lucide-react'
import { useState } from 'react'

import { supabase } from '../../lib/supabase'
import { ROLES_USUARIO } from '../../utils/usuarios'

function EditarAccesoModal({ relacion, onClose, onGuardado }) {
  const [rol, setRol] = useState(relacion?.rol || 'usuario')
  const [activo, setActivo] = useState(relacion?.activo ?? true)
  const [guardando, setGuardando] = useState(false)
  const [error, setError] = useState('')

  const cerrar = () => {
    if (guardando) return
    onClose()
  }

  const guardarAcceso = async (event) => {
    event.preventDefault()

    if (guardando) return

    setError('')

    try {
      setGuardando(true)

      const { data, error: errorActualizar } = await supabase
        .from('usuarios_empresas')
        .update({ rol, activo })
        .eq('id', relacion.id)
        .eq('empresa_id', relacion.empresa_id)
        .select()
        .single()

      if (errorActualizar) {
        throw errorActualizar
      }

      onGuardado?.(data)
    } catch (errorGuardado) {
      console.error('Error al actualizar acceso:', errorGuardado)

      if (
        errorGuardado.message?.includes('último administrador')
      ) {
        setError(
          'No puedes dejar a la empresa sin administradores activos.'
        )
      } else {
        setError(
          errorGuardado.message ||
            'No fue posible actualizar el acceso.'
        )
      }
    } finally {
      setGuardando(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/50 p-4"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          cerrar()
        }
      }}
    >
      <div className="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-xl sm:p-8">
        <div className="mb-6 flex items-start justify-between">
          <div>
            <h2 className="text-xl font-bold text-slate-900">
              Editar acceso
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              {relacion?.perfil?.nombre_completo}
              {relacion?.perfil?.correo
                ? ` — ${relacion.perfil.correo}`
                : ''}
            </p>
          </div>

          <button
            type="button"
            onClick={cerrar}
            disabled={guardando}
            aria-label="Cerrar"
            className="shrink-0 text-slate-400 transition hover:text-slate-600 disabled:cursor-not-allowed"
          >
            <X size={22} />
          </button>
        </div>

        <form
          className="space-y-5"
          onSubmit={guardarAcceso}
        >
          <div>
            <label
              htmlFor="rol"
              className="mb-2 block text-sm font-semibold text-slate-700"
            >
              Rol
            </label>

            <select
              id="rol"
              value={rol}
              onChange={(event) => setRol(event.target.value)}
              disabled={guardando}
              className={estiloInput}
            >
              {Object.entries(ROLES_USUARIO).map(
                ([valor, info]) => (
                  <option key={valor} value={valor}>
                    {info.etiqueta}
                  </option>
                )
              )}
            </select>
          </div>

          <label className="flex items-center gap-3 text-sm font-semibold text-slate-700">
            <input
              type="checkbox"
              checked={activo}
              onChange={(event) =>
                setActivo(event.target.checked)
              }
              disabled={guardando}
              className="h-4 w-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
            />
            Acceso activo
          </label>

          {error && (
            <div
              role="alert"
              className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
            >
              {error}
            </div>
          )}

          <div className="flex flex-col-reverse gap-3 pt-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={cerrar}
              disabled={guardando}
              className="w-full rounded-lg border border-slate-300 px-5 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={guardando}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-2.5 font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-emerald-400 sm:w-auto"
            >
              {guardando && (
                <LoaderCircle
                  size={18}
                  className="animate-spin"
                />
              )}

              {guardando ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const estiloInput =
  'w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 disabled:bg-slate-100'

export default EditarAccesoModal
